/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @returns {React.ReactElement} The rendered component
 */
const ClockIcon = ({ className }) => (
  <svg
    className={className}
    version="1.2"
    baseProfile="tiny"
    width="31px"
    height="31px"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 200 200"
  >
    <path
      fill="currentColor"
      d="M100,200C44.9,200,0,155.1,0,100S44.9,0,100,0s100,44.9,100,100S155.1,200,100,200z M100,18.2
	c-45.1,0-81.8,36.7-81.8,81.8s36.7,81.8,81.8,81.8s81.8-36.7,81.8-81.8S145.1,18.2,100,18.2z"
    />
    <path
      fill="#D5980C"
      d="M130.3,138.3c-1.4,0-2.8-0.3-4.1-1l-36.4-18.2c-3.1-1.5-5-4.7-5-8.1V56.5c0-5,4.1-9.1,9.1-9.1
	s9.1,4.1,9.1,9.1v48.9l31.3,15.7c4.5,2.2,6.3,7.7,4.1,12.2C136.8,136.5,133.6,138.3,130.3,138.3z"
    />
  </svg>
);

export default ClockIcon;
